module.exports = __webpack_public_path__ + "img/17.b12530cc.svg";